import template from './google-places-typeahead.html';

export default function GooglePlacesTypeahead(
    $q,
    $window,
    $timeout,
    l10nService,
    googlePlacesTypeaheadService,
    googleMapsService
) {
    'ngInject';

    return {
        template,
        restrict: 'A',
        replace: true,
        scope: {
            latitude: '=',
            longitude: '=',
            isAirport: '=',
            address: '=',
            altAddress: '=',
            cityName: '=?',
            query: '=',
            countryCode: '=',
            administrativeAreaLevel1: '=',
            openDropdown: '=?',
            placeId: '=?',
            placeTypes: '=?',
        },
        link: function(scope, elem) {
            elem.attr('placeholder', elem.attr('placeholder') || l10nService.localize('City, Hotel name, airport') + ' ...');
            elem.bind('keypress', onKeyPress);

            const placesAutocompleteService = googleMapsService.getPlacesAutocompleteService();
            const placesService = googleMapsService.getPlacesService();
            const placesServiceStatuses = googleMapsService.getPlacesServiceStatuses();

            scope.getLocation = function(input) {
                return $q((resolve, reject) => {
                    placesAutocompleteService.getQueryPredictions({input}, (response, status) => {
                            if (status === placesServiceStatuses.OK) {
                                const filteredData = placeTypesFilter(response);

                                resolve(filteredData);
                            } else {
                                reject('Google maps autocomplete service failed to return data');
                            }
                        }
                    );
                });
            };

            scope.locationSelected = function(item) {
                if (!item.place_id) {
                    scope.latitude = null;
                    scope.longitude = null;
                    scope.addressText = null;
                    scope.altAddress = null;
                    scope.cityName = null;

                    scope.$apply();
                } else {
                    scope.placeId = item.place_id;
                }

                scope.placeTypes = item.types;

                placesService.getDetails({placeId: item.place_id}, function(place) {
                    Object.assign(scope, googlePlacesTypeaheadService.extractPlaceInfo(place));
                    elem.blur();
                });
            };

            function placeTypesFilter(placeTypes) {
                return placeTypes.filter((place) => !!place.types);
            }

            function onKeyPress() {
                $timeout(() => {
                    if (angular.isDefined(scope.query)) {
                        scope.query = elem.val();
                        scope.$apply();
                    }
                }, 1);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/google-places/google-places-typeahead-directive.js